module.exports = __webpack_public_path__ + "static/img/presaleIcon_512w.95f5b5e2.png";